import { surveyFormsService } from "../../../../../Api/Services/SurveyFormsService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IFormResponsesResponse } from "../../../../../Types/SurveyFormsTypes";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

export const fetchFormResponses = createServiceAsyncThunk<
  IFormResponsesResponse,
  number
>(
  ACTION_NAMES.GET_FORM_RESPONSES,
  (formId: number) => surveyFormsService.getFormResponses(formId),
  ERROR_MESSAGES.GET_FORM_RESPONSES_FAILURE
);

export const formResponsesSlice = createGenericSlice<
  IFormResponsesResponse,
  number
>(SLICE_NAMES.FORM_RESPONSES_SLICE, fetchFormResponses);

export const {
  clearError: clearFormResponsesError,
  clearSuccessMessage: clearFormResponsesSuccessMessage,
} = formResponsesSlice.actions;

export default formResponsesSlice.reducer;
